import request from '@/utils/request';
import axios from 'axios';
import { ElMessage } from 'element-plus';

/**课程内容库 */

/**获取文件夹目录 */

//课程内容库
export function getFolderCourseTree (params) {
    return request({
        url: '/storage/api/files/tree/course',
        method: 'get',
        headers: { repeatSubmit: false },
        params,
    })
}

//仁和知识库
export function getFolderKnowledgeTree (params) {
    return request({
        url: '/storage/api/files/tree/knowledge',
        method: 'get',
        headers: { repeatSubmit: false },
        params
    })
}

// 课程内容库 + 仁和知识库
export function getFolderTree (params) {
    return request({
        url: '/storage/api/files/tree',
        method: 'get',
        headers: { repeatSubmit: false },
        params,
    })
}


//创建文件夹目录
export function createFolder (data) {
    return request({
        url: '/storage/api/files/directory',
        method: 'post',
        data
    })
}

//文件夹目录重命名
export function renameFolder (data) {
    return request({
        url: '/storage/api/files/rename',
        method: 'put',
        data
    })
}

//删除文件夹目录
export function deleteFolder (fileId) {
    return request({
        url: `/storage/api/files/${fileId}`,
        method: 'delete',
        headers: { repeatSubmit: false }
    })
}

//文件夹目录下文件搜索
export function searchFiles (data) {
    return request({
        url: '/storage/api/files/search',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}

//加强文件夹目录下的文件搜索
export function searchFilesV2 (data) {
    return request({
        url: '/storage/api/files/searchV2',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}


//新建文件素材
export function saveFilePath (data) {
    return request({
        url: '/storage/api/files/saveFilePath',
        method: 'post',
        data
    })
}


//删除文件素材
export function deleteMaterialFile (id) {
    return request({
        url: `/storage/api/files/filePath/${id}`,
        method: 'delete',
    })
}

//获取腾讯视频上传签名
export function getUploadSignature () {
    return request({
        url: '/storage/api/files/getUploadSignature',
        method: 'get',
        headers: { repeatSubmit: false }
    })
}


//视频素材预览
export function getVideoPlayToken (id) {
    return request({
        url: `/storage/api/files/getVideoPlayToken/${id}`,
        method: 'get',
        headers: { repeatSubmit: false }
    })
}

//视频转码
export function getTxyVideoProcess (id) {
    return request({
        url: `/storage/api/files/txyVideoProcess/${id}`,
        method: 'get',
        headers: { repeatSubmit: false }
    })
}


//文件下载hooks
export function useDownloadFile (source = 1) { // 1: 默认课程内容库 2: 下载电子教材
    const cancelTokenSource = ref({});
    const chunkSize = 1024 * 1024 * 5;
    //下载文件素材
    async function downloadFile (id, totalSize, fileName, callback) {
        cancelTokenSource.value[id] = axios.CancelToken.source();
        const chunkCount = Math.ceil(totalSize / chunkSize);

        let fileHandle, writableStream;
        try {
            // 请求用户选择一个文件（或创建）
            fileHandle = await window.showSaveFilePicker({
                suggestedName: fileName,
                type: {
                    description: 'All File',
                    accept: { '*/*': ['.*'] }
                }
            })
            writableStream = await fileHandle.createWritable();
            for (let i = 0; i < chunkCount; i++) {
                if (!cancelTokenSource.value[id]) break;
                const start = i * chunkSize;
                const end = Math.min(start + chunkSize - 1, totalSize - 1);
                const res = await request({
                    url: source == 2 ? `/report/teacher/attend/student/api/files/download/${id}` : `/storage/api/files/download/${id}`,
                    method: 'get',
                    headers: { 'Content-Type': 'application/octet-stream', 'Range': `bytes=${start}-${end}`, repeatSubmit: false, },
                    responseType: 'arraybuffer',
                    cancelToken: cancelTokenSource.value[id].token,
                    onDownloadProgress: (progressEvent) => {
                        const loaded = Math.ceil(((progressEvent.loaded + start) * 100) / totalSize);
                        callback && callback(loaded)
                    }
                });
                await writableStream.write(new Uint8Array(res));
            }
            ElMessage({ type: 'success', message: '文件下载成功，请到指定的文件夹中查看' });
            await writableStream.close();
        } catch {
            writableStream && await writableStream.abort(); // 出错时中止流
            throw new Error('下载失败')
        }
    }
    //下载视频文件
    async function downloadVideo (url, id, fileName, fileSize, callback) {
        cancelTokenSource.value[id] = axios.CancelToken.source();
        //获取视频长度
        const headResponse = await axios.head(url);
        const totalSize = parseInt(headResponse.headers['content-length'], 10) || fileSize;
        //分段
        const chunkCount = Math.ceil(totalSize / chunkSize);

        let fileHandle, writableStream;
        try {
            // 请求用户选择一个文件（或创建）
            fileHandle = await window.showSaveFilePicker({
                suggestedName: fileName,
                type: {
                    description: 'MP4 File',
                    accept: { '*/*': ['.mp4', '.MP4'] }
                }
            })
            writableStream = await fileHandle.createWritable();
            for (let i = 0; i < chunkCount; i++) {
                if (!cancelTokenSource.value[id]) break;
                const start = i * chunkSize;
                const end = Math.min(start + chunkSize - 1, totalSize - 1);
                const res = await axios({
                    url,
                    method: 'get',
                    responseType: 'arraybuffer',
                    headers: { 'Range': `bytes=${start}-${end}` },
                    cancelToken: cancelTokenSource.value[id].token,
                    onDownloadProgress: (progressEvent) => {
                        const loaded = Math.ceil(((progressEvent.loaded + start) * 100) / totalSize);
                        callback && callback(loaded)
                    }
                })
                await writableStream.write(new Uint8Array(res.data));
            }
            ElMessage({ type: 'success', message: '文件下载成功，请到指定的文件夹中查看' });
            await writableStream.close()
        } catch {
            writableStream && await writableStream.abort(); // 出错时中止流    
            throw new Error('下载失败')
        }
    }

    async function downloadM3U8 (url, id, fileName, callback) {
        cancelTokenSource.value[id] = axios.CancelToken.source();
        let fileHandle, writableStream;
        try {
            fileHandle = await window.showSaveFilePicker({
                suggestedName: fileName,
                types: [{
                    description: 'Video Files',
                    accept: { 'video/mp4': ['.mp4'] }
                }]
            });
            writableStream = await fileHandle.createWritable();
            const response = await fetch(url);
            const content = await response.text();
            //提取所有片段
            const lines = content.split('\n');
            const segments = [];
            let baseUrl = url.substring(0, url.lastIndexOf('/') + 1);
            for (const line of lines) {
                if (line && !line.startsWith('#')) {
                    // 处理相对路径和绝对路径
                    const segmentUrl = line.startsWith('https') ? line : baseUrl + line;
                    segments.push(segmentUrl);
                }
            }
            for (let i = 0; i < segments.length; i++) {
                const res = await axios({
                    url: segments[i],
                    method: 'get',
                    responseType: 'arraybuffer',
                    cancelToken: cancelTokenSource.value[id].token,
                })
                const loaded = Math.ceil(((i + 1) * 100 / segments.length));
                callback && callback(loaded)
                await writableStream.write(new Uint8Array(res.data));
            }

            ElMessage({ type: 'success', message: '文件下载成功，请到指定的文件夹中查看' });
            await writableStream.close()
        } catch {
            writableStream && await writableStream.abort(); // 出错时中止流
            throw new Error('下载失败')
        }
    }

    //开始下载
    function saveAs (blob, fileName) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.setAttribute('target', '_self');
        link.setAttribute('style', 'display:none');
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }, 500);
    }
    //取消下载当前文件
    function cancenlDowload (id) {
        if (cancelTokenSource.value[id]) {
            cancelTokenSource.value[id].cancel('下载已取消');
            Reflect.deleteProperty(cancelTokenSource.value, id)
        }
    }
    return {
        downloadFile,
        downloadVideo,
        downloadM3U8,
        cancenlDowload,
        saveAs,
    }
}

//获取m3u8视频
export function getM3U8Source (data, params) {
    const url = `https://playvideo.vodplayvideo.net/getplayinfo/v4/${data.subAppId}/${data.vid}`
    return axios({
        url,
        method: 'get',
        timeout: 60 * 60 * 1000,
        params
    })

}

//文件上传（不包含视频）
export function uploadFile (data, config = {}) {
    return request({
        url: '/storage/api/files/upload',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data', repeatSubmit: false },
        data,
        timeout: 60 * 60 * 1000,
        ...config,
    })
}


//文件启用与禁用
export function updateStatus (data) {
    return request({
        url: '/storage/api/files/updateStatus',
        method: 'put',
        headers: { repeatSubmit: false },
        data
    })
}


//目录/文件 有写入只读权限人员列表
export function getPermissions (data) {
    return request({
        url: `/storage/api/permissions/getPermissionList`,
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}


//文件关联课程列表
export function getRelationCourse (id, page) {
    return request({
        url: `/storage/api/files/relationCourse/${id}`,
        method: 'get',
        headers: { repeatSubmit: false },
        params: page
    })
}

//统计目录文件数量
export function getFilesCountDir (id) {
    return request({
        url: `/storage/api/files/countDir/${id}`,
        method: 'get',
        headers: { repeatSubmit: false }
    })
}

//新增授权接口
export function addPermissionsGrant (data) {
    return request({
        url: '/storage/api/permissions/grant',
        method: 'post',
        data
    })
}

//外部用户查询列表
export function searchOutsideUser (params) {
    return request({
        url: '/employee/api/users',
        method: 'get',
        headers: { repeatSubmit: false },
        params
    })
}

//内部删除文件记录
export function getDeleteLogList (data) {
    return request({
        url: '/storage/api/deleteLog/list',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}

//文件/文件夹移动
export function moveFile (data) {
    return request({
        url: '/storage/api/files/moveFile',
        method: 'put',
        customDeal: true,
        data,
    })
}

//批量授权
export function batchGrant (data) {
    return request({
        url: '/storage/api/permissions/batchGrant',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        customDeal: true,
        data
    })
}


//素材与直播绑定
export function saveFilePathByTencentLive (params) {
    return request({
        url: '/storage/api/files/saveFilePathByTencentLive',
        method: 'post',
        headers: { 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8', repeatSubmit: false },
        params
    })
}

/**授权记录 */

//授权记录列表
export function getPermissionsList (data) {
    return request({
        url: '/storage/api/permissions/list',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}

//授权记录列表
export function queryStorageFileFullPathList (params) {
    return request({
        url: '/storage/api/files/queryStorageFileFullPathList',
        method: 'post',
        headers: { repeatSubmit: false },
        params
    })
}

//选择在线素材
export function copyFile (data) {
    return request({
        url: '/storage/api/files/copyFile',
        method: 'post',
        data
    })
}


//记录视频新增观看时长
export function recordDuration (data) {
    return request({
        url: '/storage/api/record/duration',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}

//获取单个文件的访问记录
export function getRecordAccess (data, params) {
    return request({
        url: '/storage/api/record/access',
        method: 'post',
        headers: { repeatSubmit: false },
        data,
        params
    })
}


//获取电子教材列表
export function getTextbookListApi (params) {
    return request({
        url: '/contract/subject/digital/textbook/list',
        method: 'get',
        headers: { repeatSubmit: false },
        params,
    })
}


//批量删除
export function batchDelFolderFile (data) {
    return request({
        url: 'storage/api/files/filePath/batch',
        method: 'delete',
        headers: { repeatSubmit: false },
        data
    })
}

//批量禁用/启用
export function batchUpdateStatus (data) {
    return request({
        url: '/storage/api/files/updateStatus/batch',
        method: 'put',
        headers: { repeatSubmit: false },
        data
    })
}

//批量复制
export function copyCourseToPersonal (data) {
    return request({
        url: '/storage/api/files/copyCourseToPersonal',
        method: 'post',
        headers: { repeatSubmit: false },
        data
    })
}

//获取个人云盘
export function getFolderCloudTree (params) {
    return request({
        url: '/storage/api/files/tree/personal',
        method: 'get',
        headers: { repeatSubmit: false },
        params,
    })
}


/**教学备课库 */

//获取权限列表数据
export function getPositionPermissionList (params) {
    return request({
        url: '/storage/api/positionPermission/list',
        method: 'get',
        headers: { repeatSubmit: false },
        params,
    })
}


//批量删除
export function batchCancelPostlPermissions (data) {
    return request({
        url: '/storage/api/positionPermission/batchCancel',
        method: 'post',
        data
    })
}

//保存
export function savePostPermissions (data) {
    return request({
        url: '/storage/api/positionPermission/save',
        method: 'post',
        data
    })
}


//获取版本列表
export function getVersionListApi (params) {
    return request({
        url: '/storage/api/files/version/list',
        method: 'get',
        params,
    })
}